import useBottomSheetStore from 'stores/bottomSheetStore';
import { CloseOptions } from 'types/bottomsheet';

/**
 * BottomSheet를 컴포넌트 외부에서 제어할 수 있는 브리지 함수들
 * Vanilla JS 에서 사용
 */
const BottomSheetBridge = {
  /**
   * BottomSheet 열기
   */
  open: async (id: string, payload?: any) => {
    return useBottomSheetStore.getState().open(id, payload);
  },

  /**
   * BottomSheet 닫기
   */
  close: (id: string, options?: CloseOptions) => {
    useBottomSheetStore.getState().close(id, options);
  },

  /**
   * 뒤로가기 버튼 처리
   * 열린 BottomSheet가 있으면 닫고 true 반환, 없으면 false 반환
   */
  processBackButton: () => {
    const sheets = useBottomSheetStore.getState().sheets;
    const opened = Object.keys(sheets).filter((sheet) => sheets[sheet].status === 'opened' || sheets[sheet].status === 'processing');

    if (opened.length > 0) {
      const lastSheet = opened[opened.length - 1];
      if (lastSheet) {
        // 시트를 열어둔 채 페이지로 이동한 경우(예: MyProfile 시트 → 설정),
        // 화면에 가려진 시트가 백키를 먼저 소비하면 페이지는 안 닫히고 시트만 사라짐.
        // 시트보다 나중에 push된 페이지가 위에 있으면 양보해서 Transition이 페이지를 닫게 한다.
        const pagePushTime = Transition.getCurrentPagePushTime?.();
        if (pagePushTime != null && pagePushTime > sheets[lastSheet].openTime) {
          return false;
        }
        useBottomSheetStore.getState().close(lastSheet, { skipConfirm: false, reason: 'back' });
      }
      return true;
    }
    return false;
  },

  updateData: (id: string, data: Record<string, any>) => {
    useBottomSheetStore.getState().updateData(id, data);
  },

  /**
   * 특정 BottomSheet가 열려있는지 확인
   */
  isOpen: (id: string) => {
    const sheet = useBottomSheetStore.getState().sheets[id];
    return sheet?.status === 'opened' || sheet?.status === 'processing';
  },
  /**
   * 열려있는(또는 여닫는 중인) BottomSheet가 하나라도 있는지 확인
   * Vanilla 스와이프 게이트에서 사용 — 시트가 떠 있는 동안 커튼이 시트 아래로 깔리지 않게 함
   */
  isAnyOpen: () => {
    const sheets = useBottomSheetStore.getState().sheets;
    return Object.keys(sheets).some((id) => sheets[id].status === 'opened' || sheets[id].status === 'processing');
  },
};

export default BottomSheetBridge;
